// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Soe-K","right":"styles_right__3UCW7"};